import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import {
  BugComment,
  BugReport,
  BugReportFilter,
  BugReportOrderUpdate,
  CreateBugReport,
} from '../models/bug-report.model';

@Injectable({
  providedIn: 'root'
})
export class BugReportService extends BaseService{

  constructor(private http: HttpClient) {
    super(http);
  }

  find(filter: BugReportFilter, userRoles: string[]) {

    return super.put<BugReport[]>(`BugReport${this.getControllerName(userRoles)}Find`, filter);
  }

  getDetail(id: string, userRoles: string[]) {
    return super.get<BugReport>(`BugReport${this.getControllerName(userRoles)}${id}`);
  }

  getUpdates() {
    return super.get<boolean>(`BugReport/updates`);
  }

  saveComment(id: string, comment: BugComment) {
    // Error
    console.log('save comment');
  }

  create(data: CreateBugReport, files: any[], finalizeMethod: () => void) {
    let formData:FormData = new FormData();

    files.forEach(f => {
      formData.append('files', f, f.name);
    });

    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("severity", data.severity);
    formData.append("orderNumber", String(data.orderNumber));


    return super.postWithProgress(`BugReport`, formData, finalizeMethod);
  }

  createComment(data: BugComment, userRoles: string[]) {
    return super.post(`BugReport${this.getControllerName(userRoles)}comment`, data);
  }

  updateReport(data: BugReport, userRoles: string[]) {

    return super.put(`BugReport${this.getControllerName(userRoles)}`, data);
  }

  updateOrderNumbers(orderUpdates: BugReportOrderUpdate[]): Observable<void> {
    return super.put<void>('BugReport/ProdSupport/Reorder', orderUpdates);
  }

  private getControllerName(userRoles: string[]) : string {
    let controllerName = '/';
    if (userRoles.some(r => r === "admingBugReport")) {
      controllerName = "/Admin/";
    } else if (userRoles.some(r => r === "prodSupport")) {
      controllerName = "/ProdSupport/";
    }

    return controllerName;
  }
}
